import type { ReactNode } from 'react';
import clsx from 'clsx';

export interface ControlPlanePageProps {
  title: ReactNode;
  description?: ReactNode;
  breadcrumbs?: ReactNode;
  actions?: ReactNode;
  summary?: ReactNode;
  aside?: ReactNode;
  children: ReactNode;
  className?: string;
}

export function ControlPlanePage({
  title,
  description,
  breadcrumbs,
  actions,
  summary,
  aside,
  children,
  className,
}: ControlPlanePageProps) {
  return (
    <section className={clsx('vania-control-plane-page', className)}>
      <header className="vania-control-plane-page__header">
        <div className="vania-control-plane-page__heading">
          {breadcrumbs ? <div className="vania-control-plane-page__breadcrumbs">{breadcrumbs}</div> : null}
          <h1>{title}</h1>
          {description ? <p>{description}</p> : null}
        </div>
        {actions ? <div className="vania-control-plane-page__actions">{actions}</div> : null}
      </header>

      {summary ? <div className="vania-control-plane-page__summary">{summary}</div> : null}

      <div className={clsx('vania-control-plane-page__body', aside && 'vania-control-plane-page__body--with-aside')}>
        <div className="vania-control-plane-page__content">{children}</div>
        {aside ? <aside className="vania-control-plane-page__aside">{aside}</aside> : null}
      </div>
    </section>
  );
}
